import React from 'react';
import { Divider } from 'antd';
import { SocialButton, Typography } from 'ui-kit';
import { socialLoginOrCreateOwner } from 'api/auth';
import LoginForm from './LoginForm';
import './LoginPage.scss';
import UnauthLayout from 'components/UnauthLayout';

const LoginPage = () => {
  return (
    <UnauthLayout title="Welcome back!">
      <div className="LoginPage-social-login">
        <SocialButton
          social="google"
          label="Sign in with Google"
          fullWidth
          onClick={() => socialLoginOrCreateOwner('google-oauth2')}
        />
        <SocialButton
          social="facebook"
          label=" Sign in with Facebook"
          fullWidth
          onClick={() => socialLoginOrCreateOwner('facebook')}
        />
      </div>
      <Divider>
        <Typography variant="caption" color="textGray">
          OR
        </Typography>
      </Divider>
      <LoginForm />
    </UnauthLayout>
  );
};

export default LoginPage;
